import { useNavigate } from "react-router-dom";

import PageContent from "components/partials/page-content/page-content";
import BasicInfo from "containers/admin/clients/client/components/basic-info/basic-info";
import toast from "components/partials/toast/toast";
import { Typography } from "ui/typography";

import { ClientWriteBody, useCreateClient } from "hooks/api/use-clients";

import { getErrorMessage } from "utilities";
import { getClientPaths, Route } from "utilities/app-routes";
import { usePagePermission } from "hooks/use-page-permission";

import { Permission } from "types/auth";

export const AddClientPage = () => {
  const navigate = useNavigate();
  const createClientMutation = useCreateClient();

  usePagePermission(Permission.PERM_CLIENT_WRITE);

  const submitNewClient = (attributes: ClientWriteBody) => {
    createClientMutation
      .mutateAsync(attributes)
      .then((client) => {
        toast.success({
          data: {
            title: "Created client",
          },
        });
        const { clientProfilePath } = getClientPaths({ clientId: client.id });
        navigate(clientProfilePath);
      })
      .catch((err) => {
        toast.error({
          data: {
            title: "Failed to create client",
            message: getErrorMessage(err?.response?.data),
          },
        });
      });
  };

  const cancelCreateClient = () => {
    navigate(Route.clients);
  };

  return (
    <PageContent data-testid="client-new-page">
      <Typography variant="h2" sx={{ color: "secondary.main" }} className="pt-6 mb-8">
        Create client
      </Typography>
      <BasicInfo
        onSubmit={submitNewClient}
        onCancel={cancelCreateClient}
        data-testid="client-add-submit-form"
      />
    </PageContent>
  );
};
